
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as agentService from '@/services/agentService';
import type { Agent, AgentProduct } from '@/types/database.types';

export const useGetAgents = () => {
  return useQuery({
    queryKey: ['agents'],
    queryFn: agentService.getAgents
  });
};

export const useGetAgentById = (id: string) => {
  return useQuery({
    queryKey: ['agents', id],
    queryFn: () => agentService.getAgentById(id),
    enabled: !!id
  });
};

export const useCreateAgent = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: agentService.createAgent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agents'] });
    }
  });
};

export const useUpdateAgent = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<Agent> }) => 
      agentService.updateAgent(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['agents'] });
      queryClient.invalidateQueries({ queryKey: ['agents', id] });
    }
  });
};

export const useAddAgentProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: agentService.addAgentProduct,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['agents'] });
      queryClient.invalidateQueries({ queryKey: ['agents', data.agent_id] });
    }
  });
};
